import { flow } from 'lodash';

import { NAME } from './sendedEmail.constant';

export const selectRootKey = (state) => state[NAME];

const selectSendedKey = (state) => state.sended;

export const selectSended = flow(selectRootKey, selectSendedKey);
